import {
  FloatingInputGroup,
  FloatingInput,
  FloatingLabel,
  FloatingInputClearButton,
  FloatingInputLeftContent,
  FloatingInputRightContent,
  FloatingInputArrow,
  Select as SelectRoot,
  SelectTrigger,
  SelectContent,
  SelectItem,
} from "@mozioinc/ui";
import { useState } from "react";
import type { ReactNode } from "react";

type SelectProps = {
  label: string;
  icon: ReactNode;
  displayText?: string;
  options: string[];
  name: string;
  value: string;
  onValueChange?: (value: string) => void;
};

const Select = ({
  label,
  icon,
  displayText,
  options,
  value,
  onValueChange,
  name,
}: SelectProps) => {
  const [open, setOpen] = useState(false);

  return (
    <SelectRoot
      name={name}
      open={open}
      onOpenChange={setOpen}
      value={value}
      onValueChange={onValueChange}
    >
      <FloatingInputGroup focused={open} value={value} className="w-full">
        <FloatingInputLeftContent className="absolute left-2">
          <>{icon}</>
        </FloatingInputLeftContent>
        <FloatingLabel
          className="cursor-pointer"
          onClick={() => setOpen(!open)}
        >
          {label}
        </FloatingLabel>
        <SelectTrigger asChild>
          <FloatingInput asChild>
            <button type="button" className="h-14 pl-7 text-left">
              {displayText || value}
            </button>
          </FloatingInput>
        </SelectTrigger>
        <FloatingInputRightContent className="absolute right-2">
          <FloatingInputClearButton onClick={() => onValueChange?.("")} />
          <FloatingInputArrow onClick={() => setOpen(!open)} />
        </FloatingInputRightContent>
      </FloatingInputGroup>

      <SelectContent>
        {options.map((item) => (
          <SelectItem key={item} value={item}>
            {item}
          </SelectItem>
        ))}
      </SelectContent>
    </SelectRoot>
  );
};

export { Select };
